<template>
  <div class="w-screen h-screen flex flex-col items-center justify-center pb-10" style="background-color: #020308">
    <BaseText type="label" size="md" class="text-neutral-alpha-700 mb-1.5">
      Finalizing your email verification
    </BaseText>
    <BaseText type="body" size="sm" class="text-neutral-alpha-600 mb-6">
      This will only take a moment.
    </BaseText>
    <BaseLoadingLogo :width="48" :height="48" noPadding :margin="0" />
  </div>
</template>

<script>
import posthog from 'posthog-js'
import firebase from '@/api/config/FirebaseConfig'
import ForeplayAPI from '@/api/foreplayServer'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'CompleteVerificationView',
  async mounted () {
    console.log('ATTEMPTING TO COMPLETE VERIFICATION')
    try {
      
      const currentUser = firebase.auth().currentUser
      // Extract the activation code from the route params
      const oobCode = this.$route.params.oobCode

      if (!currentUser) {
        // If the user lost their auth session, we prompt them to re-enter their credentials before proceeding
        await this.logoutUser(this.$route.params.oobCode)
        return
      }

      await currentUser.reload()

      const initVerificationStatus = currentUser.emailVerified
      if (initVerificationStatus) {
        // User's email is already verified
        this.SET_IS_EMAIL_VERIFIED(true)
        this.$router.replace({ name: 'DiscoveryView' })
        return
      }

      // Apply the code to verify the email address
      await firebase.auth().applyActionCode(oobCode)
        .catch(error => {
          console.error(error)
          throw new Error("Invalid activation code. Please try again.")
        })

      // Update the user's email verification status and route them to the app
      await currentUser.reload()
      this.SET_IS_EMAIL_VERIFIED(true)

      // Execute any necessary events (Hubspot, GTags Manager, etc.)
      // GTag event
      window.dataLayer.push({
        event: 'email_verified',
        user_data: {
          email: currentUser.email,
          name: this.getUser?.name || currentUser?.displayName || 'Unknown'
        }
      })

      posthog.capture('Signed Up', {
        email: currentUser.email,
        name: this.getUser?.name || currentUser?.displayName || 'Unknown'
      })

      // Validate the email with the server (Update Hubspot property)
      await ForeplayAPI.Users.validateEmail()

      // Broadcast the email verification status to other tabs
      const bc = new BroadcastChannel('email-verification-status')
      bc.postMessage({ isEmailVerified: true })

      // Show the success alert and redirect to the onboarding page
      this.$showAlert({
        type: 'success',
        message: 'Email Verified!'
      })
      this.$router.replace({ name: 'UserOnboardView' })
      
    } catch (error) {
      console.error(error)
      this.$showAlert({
        type: 'error',
        message: error.message
      })
      this.logoutUser()
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getUser'])
  },
  methods: {
    ...mapActions('AuthModule', ['logoutUser']),
    ...mapMutations('AuthModule', ['SET_IS_EMAIL_VERIFIED'])
  }
}
</script>

<style scoped></style>